import React, { useState, useEffect } from 'react'
import { GoDotFill } from 'react-icons/go'

import dayjs from 'dayjs'
import * as RiskTypes from '../../Entities/RiskTypes'
import { useIssueStore } from './store/IssueStore'
import TaskMonitoring from '../Risk/MonitoringViewComponents/TaskMonitoring'
import ViewTasktable from '../Risk/MitigationComponents/ViewTasktable'
import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'

const IssueMonitoring = ({
    AllFormData, setAllFormData
}) => {
    const issueDetailsData = useIssueStore(state => state.issueDetailsById)
    const [ formData, setFormData ] = useState({})

    const [ departments, setDepartments ] = useState([])
    const { allDepartments } = useGovernanceStore()
    const [ updatedRiskScore, setUpdatedRiskScore ] = useState()

    useEffect(() => {
        if (allDepartments.length > 0) {
            setDepartments(allDepartments)
        }
    }, [allDepartments])

    const checkedCount = formData?.taskLists?.filter((filData, _) => filData?.actions !== 11)?.filter(item => item.actions === RiskTypes.TASK_COMPLETED_STATUS).length

    useEffect(() => {
        if (issueDetailsData?.moniteringResponse) {
            setFormData(issueDetailsData?.planningResponse)
            setUpdatedRiskScore({ impact: issueDetailsData?.moniteringResponse?.updatedScoring?.impact, impactOfRisk: issueDetailsData?.moniteringResponse?.updatedScoring?.impactOfRisk, Probability: issueDetailsData?.moniteringResponse?.updatedScoring?.probability, RiskScore: issueDetailsData?.moniteringResponse?.updatedScoring?.riskScore })
        }
    }, [issueDetailsData])

    return (
        <div className='text-primary overflow-auto flex flex-col gap-7 p-5'>
            <div className='text-primary text-subHeading-2 p-3 rounded-md bg-[hsl(var(--primary-table-head))] w-[100%] flex items-center gap-2'><GoDotFill size={8} /> Task Monitoring</div>
            <TaskMonitoring updatedRiskScore={updatedRiskScore} edit={false} formData={formData} setFormData={setFormData} type='ISSUE' />
            <div className="grid grid-cols-3 gap-4 w-full">
                <div className="flex">
                    <p className="text-[hsl(var(--primary))] text-subHeading-2">Resolution Date :</p>
                    <p className="text-muted text-b5 pl-2">
                        {dayjs(formData.resolutionDate).format('DD/MM/YYYY')}
                    </p>
                </div>

                <div className="flex">
                    <p className="text-[hsl(var(--primary))] text-subHeading-2">Task Completion Percentage :</p>
                    <p className="text-muted text-b5 pl-2">
                        {((checkedCount / formData?.taskLists?.filter((filData) => filData?.actions !== 11)?.length) * 100)?.toFixed(2)} %
                    </p>
                </div>

                <div className="flex">
                    <p className="text-[hsl(var(--primary))] text-subHeading-2">Impact Of Issue :</p>
                    <p className="text-muted break-all text-b5 pl-2">
                        {updatedRiskScore?.impactOfRisk}
                    </p>
                </div>
            </div>
            <ViewTasktable data={formData?.taskLists} formData={formData} departments={departments} />
        </div>
    )
}

export default IssueMonitoring
